/**
 * Forward the admin's real-site-preview token to a public CMS API call.
 *
 * `RealSitePreviewModal` loads the public route with `?preview_token=…`, but
 * that param only reaches the API if the page passes it on: the public route
 * bypasses the `status = 'published'` filter only when it verifies a token on
 * the *request* (`readPreviewClaim` in server/routes/public.ts). Without this,
 * every draft preview 404s and the page silently redirects to the list.
 *
 * Returns an empty string in the normal anonymous case so callers can
 * concatenate unconditionally. The language switcher never rewrites the query
 * string (i18n only reads `?locale=` at init), so the token stays readable for
 * the lifetime of the preview iframe.
 */
export function previewTokenParam(): string {
  if (typeof window === 'undefined') return ''
  const token = new URLSearchParams(window.location.search).get('preview_token')
  return token ? `&preview_token=${encodeURIComponent(token)}` : ''
}
